import React from 'react';
import qs from 'qs';
import link from 'configs/link';
import {
  MasterBg,
  Content,
  MasterInfo,
  MasterLinkBtn,
  MasterReturnBtn,
  Wrap,
  VisaBg,
  VisaLinkBtn,
  VisaReturnBtn
} from './Styles';

const Card = props => {
  const { type, card, fromList } = qs.parse(props.location.search.slice(1));
  const handleReturn = () => {
    props.history.replace(fromList ? `/list?type=${type}` : '/');
  };

  const toLink = type => {
    window.location.href = link[type];
  };

  return (
    <Wrap type={type}>
      {type === 'master' ? (
        <>
          <MasterBg />
          <Content>
            <MasterInfo card={card} />
            <MasterLinkBtn type={type} onClick={() => toLink('master')} />
            <MasterReturnBtn onClick={handleReturn}>返回上一页</MasterReturnBtn>
          </Content>
        </>
      ) : (
        <>
          <VisaBg card={card}>
            <VisaLinkBtn
              type={type}
              onClick={() =>
                toLink(['0', '1'].includes(card) ? 'visa' : 'visa2')
              }
            />
            <VisaReturnBtn onClick={handleReturn}>返回上一页</VisaReturnBtn>
          </VisaBg>
        </>
      )}
    </Wrap>
  );
};

export default Card;
